/**
 * Centralized Font Configuration
 * 
 * Use these constants throughout your app for consistent typography.
 * Works on both mobile (iOS/Android) and web platforms.
 */

import { Platform } from 'react-native';

export const FontFamily = {
  regular: Platform.select({
    ios: 'Inter-Regular',
    android: 'Inter-Regular',
    web: 'Inter-Regular, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    default: 'Inter-Regular',
  }),
  medium: Platform.select({
    ios: 'Inter-Medium',
    android: 'Inter-Medium',
    web: 'Inter-Medium, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    default: 'Inter-Medium',
  }),
  bold: Platform.select({
    ios: 'Inter-Bold',
    android: 'Inter-Bold',
    web: 'Inter-Bold, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    default: 'Inter-Bold',
  }),
};

/**
 * Usage examples:
 * 
 * import { FontFamily } from '@/constants/fonts';
 * 
 * const styles = StyleSheet.create({
 *   title: {
 *     fontFamily: FontFamily.bold,
 *     fontSize: 24,
 *   },
 *   body: {
 *     fontFamily: FontFamily.regular,
 *     fontSize: 16,
 *   },
 *   subtitle: {
 *     fontFamily: FontFamily.medium,
 *     fontSize: 18,
 *   },
 * });
 */

export default FontFamily;
